module.exports = __webpack_public_path__ + "static/fullDark-d3670952b94b42e89e1059eeaa32d7ce.png";